import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion as ChakraAccordion, } from '@chakra-ui/react';
import { AccordionVariantContext } from './accordionContext';
export function Accordion({ children, variant = 'border', ...props }) {
    return (_jsx(AccordionVariantContext.Provider, { value: variant, children: _jsx(ChakraAccordion, { variant: variant, allowToggle: true, ...props, children: children }) }));
}
//# sourceMappingURL=accordion.js.map